<template>
  <div class="wax">

    <!-- ── Conversations panel ── -->
    <div class="wax-panel">
      <div class="wax-panel__head">
        <span class="wax-panel__badge"><i class="fab fa-whatsapp"/></span>
        <span class="wax-panel__title">{{ msg('Messages') }}</span>
        <b-badge v-if="count > 0" pill class="wax-count ml-50">{{ count }}</b-badge>
        <span class="wax-panel__line"/>
        <button type="button" class="wax-icon-btn" v-b-tooltip.hover :title="msg('Reload')"
                @click="$refs['messages-table'].refresh()">
          <i class="fas fa-redo" :class="{'fa-spin': loading}"/>
        </button>
      </div>

      <!-- Conversation inbox -->
      <whatsapp-table ref="messages-table" @busy="loading = $event" @count="count = $event"/>
    </div>

  </div>
</template>


<script>
import {mapActions, mapGetters} from 'vuex'
import WhatsappTable from "@/components/tables/WhatsappTable.vue";

export default {
  components: {
    WhatsappTable,
  },
  name: 'clientMessages',
  data: () => ({
    items: [],
    loading: false,
    count: 0,
    listeners: {
      refresh: () => {
      }
    }
  }),
  watch: {
    filter: {
      deep: true,
      handler() {
      }
    },
  },
  created() {
    let $this = this;

    this.$root.$on('crm::branch-updated', (this.listeners.refresh = () => {
      $this.refresh()
    }))
  },
  beforeDestroy() {
    this.$root.$off('crm::branch-updated', this.listeners.refresh)
  },
  computed: {
    ...mapGetters('data', ['getUserFullName', 'getAllUsers', 'getUser']),
  },
  methods: {
    refresh() {
      this.$root.$emit("crm::messages-table::refresh");
    },

  }
}
</script>

<style lang="scss" scoped>
.wax-panel {
  background: #fff; border: 1px solid rgba(15, 23, 42, .06); border-radius: 16px;
  padding: 14px 18px 12px;
  box-shadow: 0 2px 10px rgba(15, 23, 42, .04);
}
.wax-panel__head { display: flex; align-items: center; gap: 8px; margin-bottom: 10px; }
.wax-panel__badge {
  width: 30px; height: 30px; border-radius: 9px; flex-shrink: 0;
  display: inline-flex; align-items: center; justify-content: center;
  background: rgba(37, 211, 102, .16); color: #1f9d57; font-size: .95rem;
}
.wax-panel__title { font-size: .82rem; font-weight: 800; text-transform: uppercase; letter-spacing: .06em; color: #475569; }
.wax-panel__line { flex: 1; height: 1px; background: linear-gradient(90deg, rgba(100, 116, 139, .18), transparent); }
.wax-count {
  background: rgba(37, 211, 102, .16); color: #1f9d57; font-weight: 800;
}
.wax-icon-btn {
  width: 30px; height: 30px; border: none; border-radius: 9px; cursor: pointer;
  display: inline-flex; align-items: center; justify-content: center;
  background: rgba(15, 23, 42, .05); color: #64748b; font-size: .74rem;
  transition: background .15s, color .15s;
  &:hover { background: rgba(37, 211, 102, .16); color: #1f9d57; }
  &:focus { outline: none; }
}
</style>

<style lang="scss">
.dark-layout {
  .wax-panel { background: #283046; border-color: rgba(255, 255, 255, .07); box-shadow: 0 2px 10px rgba(0, 0, 0, .2); }
  .wax-panel__title { color: #d0d2d6; }
  .wax-panel__line { background: linear-gradient(90deg, rgba(255, 255, 255, .12), transparent); }
  .wax-icon-btn { background: rgba(255, 255, 255, .06); color: #94a3b8; }
}
</style>
